import {ClsPeticionPresupuestos} from "./cls-pr-generico";
import {ClsPorcentajesFinanciamiento, ClsPrograma} from "../cls-programa";
import {ClsErrores} from "../cls-errores";

export class ClsPeticionUnPrograma extends ClsPeticionPresupuestos {
  IdPrograma: number;
}

export class ClsRespuestaUnPrograma {
  Programa: ClsPrograma;
  LsPorcFinanciamiento: ClsPorcentajesFinanciamiento[];
  Errores: ClsErrores;
}

export class ClsRecibirProgramas {
  LsCatalogo: ClsPrograma[];
  Errores: ClsErrores;
}

export class ClsRecibirPorcentajesFinanciamiento {
  LsPorcFinanciamiento: ClsPorcentajesFinanciamiento[];
  Errores: ClsErrores;
}

